export default __webpack_public_path__ + "static/media/markdownPreviewer.4deb7053.jpg";